import * as React from "react";
import { useCallback, useContext, useMemo } from "react";
import URI from "urijs";
import { Button } from "components/bootstrap";
import { reportingUrl } from "report/Constants";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import ExpandedSectionsContext from "components/common/EntityDataTable/contexts/ExpandedSectionsContext";
import Icon from "components/common/Icon";
import useSendIlluminateReportDownloadedTelemetry from "report/hooks/useSendIlluminateReportDownloadedTelemetry";
const downloadUrl = (reportId, jobId) => new URI(reportingUrl(`${reportId}/history/${jobId}/download`)).toString();
const detailsKey = "details";
const ReportHistoryActions = ({ report, reportHistory, disabled }) => {
  const sendTelemetry = useSendTelemetry("report-history");
  const sendIlluminateReportDownloaded = useSendIlluminateReportDownloadedTelemetry("report-history");
  const { toggleSection, expandedSections } = useContext(ExpandedSectionsContext);
  const detailsExpanded = useMemo(
    () => {
      var _a;
      return (_a = expandedSections == null ? void 0 : expandedSections[reportHistory.id]) == null ? void 0 : _a.includes(detailsKey);
    },
    [expandedSections, reportHistory.id]
  );
  const onDownload = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.REPORT.DOWNLOAD, {
      app_pathname: "report"
    });
    sendIlluminateReportDownloaded(report);
  }, [report, sendIlluminateReportDownloaded, sendTelemetry]);
  const onToggleDetails = useCallback(() => {
    toggleSection(reportHistory.id, detailsKey);
  }, [reportHistory.id, toggleSection]);
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, reportHistory.has_asset && /* @__PURE__ */ React.createElement("a", { key: "configuration-button", href: downloadUrl(report.id, reportHistory.id), rel: "noopener noreferrer" }, /* @__PURE__ */ React.createElement(Button, { disabled: !reportHistory.has_asset, bsSize: "xsmall", onClick: onDownload }, /* @__PURE__ */ React.createElement(Icon, { name: "download" }), " Download")), /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", onClick: onToggleDetails, disabled }, /* @__PURE__ */ React.createElement(Icon, { name: detailsExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down" })));
};
export default ReportHistoryActions;
